<!-- PavCon, LLC Proprietary.All rights reserved 2022 --->
<router-outlet>
  <ngx-ui-loader></ngx-ui-loader>
</router-outlet>
<!-- PavCon, LLC Proprietary.All rights reserved 2022 --->
